import { Outlet } from '@tanstack/react-router'
import { useEffect } from 'react'

import { BrandingMetadataManager } from '@/features/shared/brand/branding-provider'
import {
  portalSessionExpiredEventName,
  redirectToPortalLogin,
  type PortalSessionExpiredDetail,
} from '@/lib/auth/portal-session'

export function RootLayout() {
  useEffect(() => {
    function handleSessionExpired(event: Event) {
      redirectToPortalLogin((event as CustomEvent<PortalSessionExpiredDetail>).detail.portal)
    }

    window.addEventListener(portalSessionExpiredEventName, handleSessionExpired)
    return () => window.removeEventListener(portalSessionExpiredEventName, handleSessionExpired)
  }, [])

  return (
    <>
      <BrandingMetadataManager />
      <Outlet />
    </>
  )
}
